// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relay-tooltip {
  padding: 8px 12px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
}
.relay-tooltip .vehicle-id {
  font-weight: bold;
  margin-bottom: 4px;
}
.relay-tooltip .vehicle-data {
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/app/components/relay-tooltip/relay-tooltip.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;AAAJ","sourcesContent":[".relay-tooltip {\r\n  padding: 8px 12px;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n\r\n  .vehicle-id {\r\n    font-weight: bold;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .vehicle-data {\r\n    color: #666;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
